import React from "react";
import "../../../css/Views/TfgExportsHistory.css";
import { FiDownload, FiLoader } from "react-icons/fi";

const EXPORT_TYPE_LABELS = {
  1: "NOWE DANE",
  2: "KOREKTA",
  3: "ROZWIĄZANIE",
  4: "USUNIĘCIE",
};

const EXPORT_STATUS_LABELS = {
  1: "Oczekuje na wynik",
  2: "W UFG",
  3: "Odrzucony",
};

const EXPORT_STATUS_CLASSES = {
  1: "tfg-history-status--pending",
  2: "tfg-history-status--accepted",
  3: "tfg-history-status--rejected",
};

const formatDateTime = (value) => {
  if (!value) {
    return "—";
  }

  return new Date(value).toLocaleString("pl-PL");
};

const TfgExportsHistory = ({
  exports,
  pagination,
  isLoading,
  isActionLoading,
  onDownload,
  onPageChange,
}) => {
  return (
    <section className="tfg-history">
      <div className="tfg-history-header">
        <div>
          <h2 className="tfg-history-title">
            Historia eksportów
          </h2>

          <div className="tfg-history-subtitle">
            Lista wygenerowanych plików oraz ich statusów po
            wczytaniu do UFG.
          </div>
        </div>
      </div>

      {isLoading && !exports?.length && (
        <div className="tfg-history-state">
          Ładowanie historii eksportów...
        </div>
      )}

      {!isLoading && !exports?.length && (
        <div className="tfg-history-state">
          Nie wygenerowano jeszcze żadnego eksportu.
        </div>
      )}

      {!!exports?.length && (
        <>
          <div className="tfg-history-table-wrapper">
            <table className="tfg-history-table">
              <thead>
                <tr>
                  <th>Wygenerowano</th>
                  <th>Plik</th>
                  <th>Umowy</th>
                  <th>Wygenerował</th>
                  <th>Status</th>
                  <th>Zaakceptowano</th>
                </tr>
              </thead>

              <tbody>
                {exports.map((exportItem) => (
                  <tr key={exportItem.id}>
                    <td>
                      {formatDateTime(
                        exportItem.generatedAt
                      )}
                    </td>

                    <td title={exportItem.fileName}>
                      <button
                        type="button"
                        className="tfg-history-file-link"
                        onClick={() =>
                          onDownload(
                            exportItem.id,
                            exportItem.fileName
                          )
                        }
                        disabled={
                          isActionLoading ||
                          !exportItem.id
                        }
                      >
                        <FiDownload size={14} />

                        <span>
                          {exportItem.fileName}
                        </span>
                      </button>
                    </td>

                    <td>{exportItem.itemsCount}</td>

                    <td>
                      {exportItem.generatedBy || "—"}
                    </td>

                    <td>
                      <span
                        className={`tfg-history-status ${
                          EXPORT_STATUS_CLASSES[
                            exportItem.status
                          ] ??
                          "tfg-history-status--unknown"
                        }`}
                      >
                        {EXPORT_STATUS_LABELS[
                          exportItem.status
                        ] ??
                          `Nieznany (${exportItem.status})`}
                      </span>
                    </td>

                    <td>
                      {exportItem.status === 2
                        ? formatDateTime(
                            exportItem.acceptedAt
                          )
                        : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

{pagination?.totalPages > 1 && (
  <div className="tfg-history-pagination">
    <div className="tfg-history-pagination-side">
      {pagination.hasPreviousPage && (
        <div
          className={`tfg-history-pagination-button ${
            isLoading
              ? "tfg-history-pagination-button--disabled"
              : ""
          }`}
          role="button"
          tabIndex={isLoading ? -1 : 0}
          onClick={() => {
            if (!isLoading && !isActionLoading) {
              onPageChange(pagination.page - 1);
            }
          }}
          onKeyDown={(event) => {
            if (
              !isLoading &&
              !isActionLoading &&
              (event.key === "Enter" ||
                event.key === " ")
            ) {
              event.preventDefault();
              onPageChange(pagination.page - 1);
            }
          }}
        >
          Poprzednia
        </div>
      )}
    </div>

    <div className="tfg-history-pagination-info">
      {isLoading ? (
        <FiLoader
          className="tfg-history-pagination-loader"
          size={20}
        />
      ) : (
        <>
          Strona {pagination.page} z{" "}
          {pagination.totalPages}
        </>
      )}
    </div>

    <div className="tfg-history-pagination-side tfg-history-pagination-side--right">
      {pagination.hasNextPage && (
        <div
          className={`tfg-history-pagination-button ${
            isLoading
              ? "tfg-history-pagination-button--disabled"
              : ""
          }`}
          role="button"
          tabIndex={isLoading ? -1 : 0}
          onClick={() => {
            if (!isLoading && !isActionLoading) {
              onPageChange(pagination.page + 1);
            }
          }}
          onKeyDown={(event) => {
            if (
              !isLoading &&
              !isActionLoading &&
              (event.key === "Enter" ||
                event.key === " ")
            ) {
              event.preventDefault();
              onPageChange(pagination.page + 1);
            }
          }}
        >
          Następna
        </div>
      )}
    </div>
  </div>
)}
        </>
      )}
    </section>
  );
};

export default TfgExportsHistory;